<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">
            <!-- <span class="grey--text"></span> -->
            {{ data.name }}</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- <v-form v-model="valid" ref="form">
            <v-select
              v-model="userRole"
              :items="roles"
              :item-text="roles.tesxt"
              menu-props="auto"
              label="Select role"
              required
              :rules="[() => !!userRole || 'This field is required']"
              outlined
              hide-details
              prepend-icon=" mdi-wrench"
              single-line
              class="dl-mb-10"
            >
            </v-select>
          </v-form> -->
        </v-card-text>

        <v-card-text>
          <!-- <span class="headline"
            >حذف <span class="black--text"> {{ data.name }}</span></span
          > -->
          <v-sheet class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block">
            <div class="red--text text--lighten-1 text-body-3 mb-4">
              {{ $t("employees.deleteUser.warning") }}
            </div>

            <v-btn
              class="ma-1"
              color="error"
              plain
              outlined
              :loading="removing"
              @click="deleteEmployee(data.id)"
            >
              {{ $t("employees.deleteUser.btn") }}
            </v-btn>
          </v-sheet>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">
            {{ $t("btn.cancel") }}
          </v-btn>
          <!-- <v-btn color="green" @click.prevent="setRole" :loading="saving" dark>
            Set
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["dialog", "data"],

  data() {
    return {
      valid: true,
      removing: false,
      saving: false,
    };
  },
  computed: {},
  methods: {
    ...mapActions("employees", ["deleteOne", "list"]),
    close() {
      this.removing = false;
      this.$emit("close-dialog", false);
    },
    deleteEmployee(id) {
      this.removing = true;
      // const payload = {
      //   id: id,
      // };

      this.deleteOne(id).then((res) => {
        this.list();
        this.$emit("close-dialog", false);
      });
      this.removing = false;
    },
  },
};
</script>
